var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45959 22.0577C9.08491 21.9254 12.8953 21.9254 13.5206 22.0577C14.0552 22.1811 14.6333 22.4696 14.6333 23.0995C14.6022 23.6992 14.2504 24.2309 13.7643 24.5685C13.134 25.0598 12.3943 25.371 11.621 25.4831C11.1934 25.5386 10.7732 25.5398 10.3604 25.4831C9.58592 25.371 8.84622 25.0598 8.21716 24.5672C7.72983 24.2309 7.37801 23.6992 7.34693 23.0995C7.34693 22.4696 7.92501 22.1811 8.45959 22.0577ZM11.0639 0.507813C13.6659 0.507813 16.3239 1.74244 17.9027 3.79092C18.9271 5.10996 19.397 6.42774 19.397 8.47622V9.00912C19.397 10.5801 19.8123 11.5061 20.726 12.5732C21.4185 13.3593 21.6398 14.3684 21.6398 15.4632C21.6398 16.5567 21.2805 17.5948 20.5607 18.4377C19.6183 19.448 18.2894 20.0931 16.933 20.2052C14.9676 20.3728 13.0008 20.5139 11.008 20.5139C9.01392 20.5139 7.04844 20.4295 5.08296 20.2052C3.7254 20.0931 2.39643 19.448 1.45533 18.4377C0.735525 17.5948 0.375 16.5567 0.375 15.4632C0.375 14.3684 0.597531 13.3593 1.28874 12.5732C2.23108 11.5061 2.61896 10.5801 2.61896 9.00912V8.47622C2.61896 6.37231 3.14358 4.99658 4.22392 3.64982C5.83012 1.68575 8.40476 0.507813 10.9521 0.507813H11.0639Z",
    fill: "#2B2B36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.d53b8140f822474c803a0c805e3f686a.svg";
export { ForwardRef as ReactComponent };